// extracted by mini-css-extract-plugin
var _1 = "SearchInput2_clear__8tYSD";
var _2 = "SearchInput2_searchBtn__AOw07";
var _3 = "SearchInput2_searchInput__X0XWu";
export { _1 as "clear", _2 as "searchBtn", _3 as "searchInput" }
